/**
 * ============================================================================
 * useAuditPlansQuery — Phase 7 frontend
 * Owner: Phase 7 — Internal Audit Programme Module.
 * Purpose: TanStack Query hook for the annual audit-plan list.
 * Endpoint: GET /api/v1/audit-plans
 * URS rows: INA-002.
 * ============================================================================ */

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiFetch } from '../../api/client';
import type { AuditPlan, PageResponse } from './types';

export function useAuditPlansQuery(): UseQueryResult<PageResponse<AuditPlan>, Error> {
  return useQuery<PageResponse<AuditPlan>, Error>({
    queryKey: ['internal-audit', 'plans'],
    queryFn: () => apiFetch<PageResponse<AuditPlan>>('/api/v1/audit-plans'),
    staleTime: 60_000,
  });
}
